exports = module.exports = require("../../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title-box[data-v-0005cdee] {\n  font-size: 16px;\n  font-weight: 500;\n  margin-bottom: 10px;\n  position: relative;\n}\n.title-box[data-v-0005cdee]::before {\n  content: \" \";\n  background-color: #409eff;\n  width: 4px;\n  height: 100%;\n  border-radius: 1px;\n  position: absolute;\n  left: -10px;\n}\n.tipsBox[data-v-0005cdee] {\n  display: inline-block;\n  font-size: 13px;\n  color: #9f9f9f;\n  margin-left: 10px;\n}\n.disabled[data-v-0005cdee]  .el-upload--picture-card {\n  display: none;\n}\n.disabled[data-v-0005cdee]  .el-upload__tip {\n  margin-top: -10px;\n}", ""]);

// exports
